import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asahsott',
  templateUrl: './asahsott.component.html',
  styleUrls: ['./asahsott.component.scss']
})
export class AsahsottComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
